import React from "react";
import { ModalTitle, Modal, ModalBody } from "@vds/modals";
import { Body, Title,Micro } from "@vds/typography";
import { Button } from "@vds/buttons";
import { Grid, Row, Col } from "@vds/grids";
import { useMediaQuery } from "react-responsive";
import {
    InternetGatewayModal as IGModal ,
    JointOfferModal,
    ButtonContainer, ModalBodyPopUp } from "../FWA/EquipmentSection/styles";
import { MarginSpacerM } from "../styleTag";
import styled from "styled-components";
import { Text } from "@vds/core";


export default function JointOfferCardModalNew(props) {

const isMobile = useMediaQuery({
  query: "(max-width: 545px)",
});
const getUnorderListBottom = ()=>{
    return(
      <>
         <ol>
          {props?.aemContent?.BulletPointsContent.map((item) => {
                  return <li size="bodyLarge" >
                    <Text kind="body" size="large">{item?.BulletDisc}</Text>
                  </li>
                })}
        </ol>
      </>
    )
  }

  return (
      <JointOfferModal
        ariaLabel=""
        opened={props.showModal}
        onOpenedChange={props.setShowModal}
        zIndex={1000000}
        disableFocusLock={true}
      >
        <ModalTitle>
          <Title size="medium" bold={true}>
            <div dangerouslySetInnerHTML={{ __html: props?.aemContent.modalTitle }}></div>
          </Title>
          <Title size="medium" bold={true}>
            <div dangerouslySetInnerHTML={{ __html: props?.aemContent.subModalTitle }}></div>
          </Title>
        </ModalTitle>

        {/* modalBody */}
        <ModalBodyPopUp>

          <Body size="large">
            <div
              dangerouslySetInnerHTML={{ __html: props?.aemContent?.subHeading }}
            ></div>
          </Body>
          <MarginSpacerM />
          <Body size="large" bold={true}>
            <div
              dangerouslySetInnerHTML={{ __html: props?.aemContent?.listHeading }}
            ></div>
          </Body>
          <MarginSpacerM />
          {<>
            <ListItemsWrapper>{getUnorderListBottom()}</ListItemsWrapper>
          </>}
          <>
            <MarginSpacerM />
            {props?.aemContent?.microContent?.map((element, id) => {
              return (
                <>
                  <Micro size="large" color="#6F7171">
                    <span dangerouslySetInnerHTML={{ __html: element }} />
                  </Micro>
                  <MarginSpacerM />
                </>
              );
            })}
            <MarginSpacerM />
          </>

        </ModalBodyPopUp>

        <ButtonContainer>
          <Button
            width={isMobile ? "360px" : "140px"}
            onClick={() => {
              props.setShowModal(false);
            } }
            disabled={false}
          >
            Close
          </Button>
        </ButtonContainer>
      </JointOfferModal> 
     
  );
}

const ListItemsWrapper = styled.div`
  ol {padding-left:14px;
    li {margin-top:1rem;    
      & > p {padding-left:8px;}
    }
  }
 @media screen and (min-width: 320px) and (max-width: 560px) {
    ol {
      width:324px !important;
    }
  }
    `